<template>
  <div class="kf-dialog-cpn">
    <el-dialog :visible.sync="dialogVisible"
               custom-class="kf-dialog"
               @close="close"
               width="500px"
               height="436px">
      <div style="font-size: 16px;color: #000;text-align: center;font-weight: 700">
        你好新同学，你还没有领取过试用
      </div>
      <div style="font-size: 16px;color: #2f4eff;text-align: center;font-weight: 400">
        扫码添加魔镜小助手, 免费领取3次提问机会~
      </div>
      <div style="display: flex; justify-content: center; align-items: center;margin-top: 20px">
        <img v-if="$store.state.user.kfImgUrl"
             :src="$store.state.user.kfImgUrl"
             style="width: 160px;"
             alt="">
      </div>

      <div style="color: #ababab; font-size: 14px; text-align: center; font-weight: 400;margin-top:30px">领取试用成功后，关闭此弹窗，就可以开始提问啦</div>
    </el-dialog>
  </div>
</template>


<script>
import { getUserInfo } from '@/api/user'
export default {
  name: 'KfDialog',
  data() {
    return {}
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible() {
      return this.visible
    },
  },
  methods: {
    close() {
      getUserInfo().then((res) => {
        this.$store.dispatch('user/changeLoginInfo', res.result)
      })
      this.$emit('close')
      // window.location.reload()
    },
  },
  created() {},
}
</script>

<style lang="less">
.kf-dialog {
  line-height: 30px;
  border-radius: 32px !important;
  .el-dialog__body {
    padding: 30px 20px 40px 20px !important;
  }
  .el-icon-close:before {
    background-color: #ababab;
    border-radius: 50%;
    padding: 2px;
    color: #fff;
    font-weight: 800;
    font-size: 15px;
  }
}
</style>
